/**
 * @module registration/client/components/step2
 */

import React, { Component, PropTypes } from 'react';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import { Link } from 'react-router';
import { SubmissionError } from 'redux-form';
import { updateUserRequest, profileDefaults } from 'common/ducks/user';
import Step2Form from 'registration/client/components/step2_form';
import { setGoogleDimension, trackGoogle } from 'common/tracking';
import { isUsernameGenerated } from 'account/utils';


/**
 * Second and final step of client registration.
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
class Step2 extends Component {
  constructor(props) {
    super(props);
    this.state = { done: false };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.fetchTimezonesIfNeeded();
    this.props.fetchLeadSourcesIfNeeded();
    this.props.fetchIndustriesIfNeeded();
    this.props.fetchCategoriesIfNeeded();
  }

  handleSubmit(formData) {
    return updateUserRequest(this.props.user.profile_data.id, formData)
      .then((res) => {
        this.setState({ done: true });
        this.props.updateUserLocal(res.data);
        setGoogleDimension('dimension1', res.data.user_converted_from);
        trackGoogle("registration", "verified email", "client");

      })
      .catch((res) => {
        /* field-specific errors */
        const data = res.data;
        if (data) {
          for (const field of Object.keys(data)) {
            if (data[field]) throw new SubmissionError({ [field]: data[field][0] });
          }
        }
        /* global error */
        throw new SubmissionError({ _error: 'Unknown error. Please try again.' });
      });
  }

  render() {
    const { done } = this.state;
    const { user, industryChoices, categoryChoices } = this.props;
    /* get non-empty values from `profile_data`, otherwise use values from `profileDefaults` */
    const initialValues = {
      ...profileDefaults,
      ...pickBy(user.profile_data, identity),
    };
    /* if username was generated, make it empty so that client is forced to enter one */
    if (isUsernameGenerated(initialValues.username)) {
      initialValues.username = '';
    }

    return (
      <div id="content" className="l-content registration client step2">
        <div className="row align-center">
          <div className="columns small-16 medium-12 large-8">
            {done ?
            <div className="done">
              <h2 className="text-success">
                <i className="fa fa-check-circle" /> Account Created!
              </h2>
              <p>Your account was successfully created.<br />
                 Ready to start your first project?</p>
                <Link to="/start-a-project/" className="btn btn-primary">Get started</Link>
            </div>:
            <div>
              <h2>Welcome back!<br /> Let&apos;s finish creating your account.</h2>

              <Step2Form
                onSubmit={this.handleSubmit}
                initialValues={initialValues}
                tzChoices={user.timezones}
                leadChoices={user.leadSources}
                industryChoices={industryChoices}
                categoryChoices={categoryChoices}
                showLeadSourceField={!user.profile_data.lead_source}
                lazyRegistered={user.profile_data.is_lazy_registered}
              />
            </div>}
          </div>
        </div>
      </div>
    );
  }
}

/**
 * PropTypes.
 *
 * @property {object} user - logged in user
 * @property {array} industryChoices - available industry choices
 * @property {array} categoryChoices - available category choices
 * @property {func} fetchTimezonesIfNeeded - fetch available timezones if not already
 * @property {func} fetchLeadSourcesIfNeeded - fetch available lead sources if not already
 * @property {func} fetchIndustriesIfNeeded - fetch available industries if not already
 * @property {func} fetchCategoriesIfNeeded - fetch available categories if not already
 * @property {func} updateUserLocal - update user locally
 */
Step2.propTypes = {
  user: PropTypes.object,
  industryChoices: PropTypes.array,
  categoryChoices: PropTypes.array,
  fetchTimezonesIfNeeded: PropTypes.func,
  fetchLeadSourcesIfNeeded: PropTypes.func,
  fetchIndustriesIfNeeded: PropTypes.func,
  fetchCategoriesIfNeeded: PropTypes.func,
  updateUserLocal: PropTypes.func,
};

export default Step2;



// WEBPACK FOOTER //
// ./registration/client/components/step2.jsx